// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_main__nav_wrapper__a58SX {
    width: auto;
    max-width: 1440px;
    height: 50px;
    display: flex;
    padding: 17px 80px;
    margin: 0px auto;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ECECEC;
    background-color: var(--neutrals-white);
}

.style_main__nav_wrapper__a58SX>ul {
    padding: 0;
    width: 40%;
    display: flex;
    min-width: 290px;
    max-width: 335px;
    list-style: none;
    justify-content: space-between;
}

.style_main__nav_wrapper__a58SX li,
.style_main__nav_wrapper__a58SX a,
.style_menu__dropdown__oa8NF a {
    cursor: pointer;
    font-weight: 400;
    color: var(--grey-09);
    text-decoration: none;
}

.style_main__nav_wrapper__a58SX .style_active__r\\+DQ9,
.style_menu__dropdown__oa8NF .style_active__r\\+DQ9 {
    font-weight: 600 !important;
}

/* Mobile Menu */
.style_mobile__nav_wrapper__IqWTF {
    width: auto;
    height: 76px;
    display: none;
    padding: 7px 20px;
    position: sticky;
    top: 0px;
    z-index: 4;
    border-bottom: 1px solid #ECECEC;
    background-color: var(--neutrals-white);
}

.style_menu__dropdown__oa8NF {
    width: 100%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 6vh;
    position: fixed;
    padding: 20px;
    height: calc(100vh - 91px);
    background-color: white;
}

.style_menu__dropdown__oa8NF~main {
    overflow-y: hidden;
    position: fixed;
    z-index: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/navs/style.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;IACR,UAAU;IACV,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;AACd","sourcesContent":[".main__nav_wrapper {\n    width: auto;\n    max-width: 1440px;\n    height: 50px;\n    display: flex;\n    padding: 17px 80px;\n    margin: 0px auto;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #ECECEC;\n    background-color: var(--neutrals-white);\n}\n\n.main__nav_wrapper>ul {\n    padding: 0;\n    width: 40%;\n    display: flex;\n    min-width: 290px;\n    max-width: 335px;\n    list-style: none;\n    justify-content: space-between;\n}\n\n.main__nav_wrapper li,\n.main__nav_wrapper a,\n.menu__dropdown a {\n    cursor: pointer;\n    font-weight: 400;\n    color: var(--grey-09);\n    text-decoration: none;\n}\n\n.main__nav_wrapper .active,\n.menu__dropdown .active {\n    font-weight: 600 !important;\n}\n\n/* Mobile Menu */\n.mobile__nav_wrapper {\n    width: auto;\n    height: 76px;\n    display: none;\n    padding: 7px 20px;\n    position: sticky;\n    top: 0px;\n    z-index: 4;\n    border-bottom: 1px solid #ECECEC;\n    background-color: var(--neutrals-white);\n}\n\n.menu__dropdown {\n    width: 100%;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    gap: 6vh;\n    position: fixed;\n    padding: 20px;\n    height: calc(100vh - 91px);\n    background-color: white;\n}\n\n.menu__dropdown~main {\n    overflow-y: hidden;\n    position: fixed;\n    z-index: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main__nav_wrapper": `style_main__nav_wrapper__a58SX`,
	"menu__dropdown": `style_menu__dropdown__oa8NF`,
	"active": `style_active__r+DQ9`,
	"mobile__nav_wrapper": `style_mobile__nav_wrapper__IqWTF`
};
export default ___CSS_LOADER_EXPORT___;
